import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // the usual syntax for this throws an error - not sure why
  static get values() {
    return { id: Number };
  }

  static get targets() {
    return ["select"];
  }

  handleSelect() {
    const action = this.selectTarget.value;
    this.selectTarget.value = ""; // reset the select
    const frame = document.getElementById("bulk_approval_transaction_confirm");

    if (action === "") {
      return;
    } else if (action === "reassign") {
      window.replaceBulkApprovalEntity(this.idValue);
      return;
    } else if (action == "edit") {
      frame.src = `${this.baseUrl()}/bulk_approval_transactions/${this.idValue}/edit_entity`;
      return;
    }

    frame.src = `${this.baseUrl()}/bulk_approval_transactions/${this.idValue}/confirm_action?action_type=${action}`;
  }

  baseUrl() {
    let baseUrl = window.location.href;
    let bulkApprovalsIndex = baseUrl.indexOf("bulk_approvals");
    if (bulkApprovalsIndex !== -1) {
      baseUrl = baseUrl.substring(0, bulkApprovalsIndex);
    }
    return baseUrl;
  }
}
